/*
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2021-08-26 16:58:26
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'

import login from './modules/login'
import user from './modules/user'
import page from './modules/page'
import menu from './modules/menu'

import createPersistedState from "vuex-persistedstate"

import getters from './getters'
Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [createPersistedState({
        storage:window.sessionStorage,
        reducer(state) {
            return {
                // 只储存state中的user
                // user: state.user,
            }
        }
    })],
    modules: {
        login,
        user,
        page,
        menu,
    },
    getters
})

export default store
